__turbopack_context__.v({
  "duplicate": "BIbp2G_duplicate",
  "group": "BIbp2G_group",
  "reviews-scroll": "BIbp2G_reviews-scroll",
  "track": "BIbp2G_track",
  "viewport": "BIbp2G_viewport",
});
